import { API, api } from "./api";

const ROOT = API.replace(/\/api$/, "");

export function money(cents, currency = "AUD") {
  try {
    return new Intl.NumberFormat("en-AU", { style: "currency", currency }).format((cents || 0) / 100);
  } catch {
    return `$${((cents || 0) / 100).toFixed(2)}`;
  }
}

export function storeImg(img) {
  if (!img || !img.src) return null;
  return img.src.startsWith("http") ? img.src : ROOT + img.src;
}

// Guest shopping: a client-side cart token so anonymous visitors can build a cart & check out.
export function getCartToken() {
  let t = localStorage.getItem("store_cart_token");
  if (!t) {
    t = (window.crypto?.randomUUID ? window.crypto.randomUUID() : `g-${Date.now()}-${Math.random().toString(16).slice(2)}`);
    localStorage.setItem("store_cart_token", t);
  }
  return t;
}
export function clearCartToken() { localStorage.removeItem("store_cart_token"); }
// cart_token only when NOT logged in
export const cartTok = (user) => (user ? undefined : getCartToken());

// Persistent anonymous storefront session id (for funnel / behaviour analytics).
export function storeSid() {
  let s = localStorage.getItem("store_sid");
  if (!s) {
    s = (window.crypto?.randomUUID ? window.crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(16).slice(2)}`);
    localStorage.setItem("store_sid", s);
  }
  return s;
}

// Fire-and-forget funnel tracking. Never blocks or throws into the UI.
export function trackStore(type, extra = {}) {
  try {
    api.post("/store/track", {
      session_id: storeSid(),
      type,
      cart_token: localStorage.getItem("store_cart_token") || undefined,
      path: typeof window !== "undefined" ? window.location.pathname : undefined,
      ...extra,
    }).catch(() => {});
  } catch { /* ignore */ }
}

export const ORDER_STATUS_LABEL = {
  pending_payment: "Pending Payment", paid: "Paid", processing: "Processing",
  awaiting_fulfilment: "Awaiting Fulfilment", partially_fulfilled: "Partially Fulfilled",
  shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled",
  refunded: "Refunded", failed: "Failed",
};

export const ORDER_STATUS_COLOR = {
  pending_payment: "#FFB703", paid: "#2EC4B6", processing: "#3498DB",
  awaiting_fulfilment: "#FFB703", partially_fulfilled: "#3498DB",
  shipped: "#2ECC71", delivered: "#2ECC71", cancelled: "#E4443A",
  refunded: "#94A3B8", failed: "#E4443A",
};
